import React, { useContext, useEffect, createContext, useState } from 'react';

// peoject-imports
import { showToast } from '../components/sweet-alert/Sweetalert';
import { useDomainContext } from './domain_context';
import { delCourseComment, getCourseComments, getCourseCommentsByCourseId, getCourses, getCoursesV2, getUserReactionsByParentId, postCourseComment, postUserReactions, putCourseComment, putCourseCommentLike, putCourseLike } from './salesforce_api_context';
import { ADD_COURSE_COMMENT_BEGIN, ADD_COURSE_COMMENT_FAILURE, ADD_COURSE_COMMENT_SUCCESS, DELETE_COURSE_COMMENT_BEGIN, DELETE_COURSE_COMMENT_FAILURE, DELETE_COURSE_COMMENT_SUCCESS, GET_COURSE_COMMENT_BEGIN, GET_COURSE_COMMENT_FAILURE, GET_COURSE_COMMENT_SUCCESS, GET_COURSE_USER_REACTION_BEIGN, GET_COURSE_USER_REACTION_FAILURE, GET_COURSE_USER_REACTION_SUCCESS, GET_COURSES_BEGIN, GET_COURSES_FAILURE, GET_COURSES_SUCCESS, GET_DOMAIN_SUCCESS, GLOBAL_SEARCH_COURSES_SUCCESS, PUT_COURSE_LIKES_BEGIN, PUT_COURSE_LIKES_FAILURE, PUT_COURSE_LIKES_SUCCESS, SET_USER_REACTION_BEGIN, SET_USER_REACTION_FAILURE, SET_USER_REACTION_SUCCESS, UPDATE_COURSE_COMMENT_BEGIN, UPDATE_COURSE_COMMENT_FAILURE, UPDATE_COURSE_COMMENT_SUCCESS } from '../constants/actions';
import courses from '../data/course/CourseData.json';
import coursesComments from '../data/course/courseComments.json';

// third-party
import { useDispatch, useSelector } from "react-redux";

// Create context
export const CoursesContext = createContext();

// Reading environment variable start
const SALESFORCE_COURSE_DOMAIN = process.env.REACT_APP_SALESFORCE_COURSE_DOMAIN;
const REACTJS_COURSE_DOMAIN = process.env.REACT_APP_REACTJS_COURSE_DOMAIN;
const JAVASCRIPT_COURSE_DOMAIN = process.env.REACT_APP_JAVASCRIPT_COURSE_DOMAIN;
// Reading environment variable end

export const CoursesProvider = (props) => {

    // Constant variables
    const location = document.location;
    const currentPath = location.href || "";
    const currentCourseDomainUrl = currentPath && currentPath.includes("react-js") ? REACTJS_COURSE_DOMAIN : currentPath && (currentPath.includes("salesforce")) ? SALESFORCE_COURSE_DOMAIN : currentPath && (currentPath.includes("javascript")) ? JAVASCRIPT_COURSE_DOMAIN : "all";

    // Reading store data
    const { coursesDomain } = useDomainContext();

    // Local state initialization
    const [currentDomain, setCurrentDomain] = useState("");

    // Reading dispatch from Store
    const dispatch = useDispatch();

    // Reading store data
    const courseState = useSelector(state => state.courses);

    // Constant functions

    // Fucntion to get courses
    const fetchCourses = async (domainParam) => {

        // Configuring filters for the API
        let filters = [
            {
                "field": "domain",
                "operator": "EQUAL",
                "value": domainParam || currentDomain || coursesDomain,
            }
        ];
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: GET_COURSES_BEGIN, payload: true });

            // Calling API to get course list 
            let coursesData = await getCourses(filters);

            // Dispatching the actions on success
            dispatch({ type: GET_COURSES_SUCCESS, payload: coursesData });
            dispatch({ type: GET_DOMAIN_SUCCESS, payload: coursesDomain });

            if (currentDomain !== currentCourseDomainUrl) {
                setCurrentDomain(currentCourseDomainUrl);
            }

            // Showing the toast message on getting all courses successfully
            // showToast("success", "Getting courses successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("74 : courses_context : Error while fetching the courses::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_COURSES_FAILURE, payload: error && error.message });

            // Showing the toast message on getting all courses unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the courses!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }

    // Function to update likes to course (requires token for authentication)
    const updateCourseLikes = async (courseId, payload) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: PUT_COURSE_LIKES_BEGIN, payload: true });
            console.log("coursesData payload => ", payload);
            // Calling API to put course like 
            let coursesData = await putCourseLike(courseId, payload);
            // let coursesData = [];

            console.log("coursesData => ", coursesData);

            // Dispatching the actions on success
            dispatch({ type: PUT_COURSE_LIKES_SUCCESS, payload: coursesData })

            // Showing the toast message on adding like to the course successfully 
            // showToast("success", "Like added successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.error('101 : courses_context : Error while adding like to the course::', error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: PUT_COURSE_LIKES_FAILURE, payload: error && error.message });

            // Showing the toast message on adding like to the course unsuccessfully 
            showToast("error", (error && error.message) ? "We are unable to update like to this course!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to get course comments (requires token for authentication)
    const fetchCourseComments = async (courseId) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: GET_COURSE_COMMENT_BEGIN, payload: true });

            // Calling API to get course comments 
            let response = await getCourseComments(courseId);
            // let response = [];

            // Dispatching the actions on success
            dispatch({ type: GET_COURSE_COMMENT_SUCCESS, payload: response });

            // Showing the toast message on getting course comments successfully
            // showToast("success", "Getting course comments successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("128 : courses_context : Error while fetching course comments::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_COURSE_COMMENT_FAILURE, payload: error.message });

            // Showing the toast message on getting course comments unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the latest comments!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to get filtered course comment (requires token for authentication)
    const getFilteredCourseComment = async (courseId) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: GET_COURSE_COMMENT_BEGIN, payload: true });

            // Calling API to get course comments by courseId
            let coursesData = await getCourseCommentsByCourseId(courseId);
            // let coursesData = coursesComments || [];

            // Dispatching the actions on success
            dispatch({ type: GET_COURSE_COMMENT_SUCCESS, payload: coursesData })

            // Showing the toast message on getting coures comments by courseId successfully 
            // showToast("success", "Getting course comments successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.error('155 : courses_context : Error while fetching filtered course comment::', error && JSON.stringify(error));

            // Disptaching the actions on error 
            dispatch({ type: GET_COURSE_COMMENT_FAILURE, payload: error && error.message });

            // Showing the toast message on getting course comment by blogId unsuccessfully 
            showToast("error", (error && error.message) ? "We are unable to get the comment of this course!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to add comment to the course (requires token for authentication)
    const insertCourseComment = async (payload) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: ADD_COURSE_COMMENT_BEGIN, payload: true });

            // Calling API to post course comment  
            let coursesData = await postCourseComment(payload);
            // let coursesData = [];

            // Dispatching the actions on success
            dispatch({ type: ADD_COURSE_COMMENT_SUCCESS, payload: coursesData })

            // Showing the toast message on adding course comment successfully
            // showToast("success", "Comment added successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.error('182 : courses_context : Error while adding comment to the course::', error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: ADD_COURSE_COMMENT_FAILURE, payload: error && error.message });

            // Showing the toast message on adding comment to the course unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to post the comment to this course!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to update comment to the course (requires token for authentication)
    const updateCourseComment = async (commentId, payload, userId) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: UPDATE_COURSE_COMMENT_BEGIN, payload: true });

            // Calling API to update course comment 
            let coursesData = await putCourseComment(commentId, payload, userId);
            // let coursesData = [];

            // Dispatching the actions on success
            dispatch({ type: UPDATE_COURSE_COMMENT_SUCCESS, payload: coursesData })

            // Showing the toast message on comment update successfully
            // showToast("success", "Comment updated successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.error('209 : courses_context : Error while updating comment to the course', error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: UPDATE_COURSE_COMMENT_FAILURE, payload: error && error.message });

            // Showing the toast message on updating course comment unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to update comment to this course!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to put(update) like course comment (requires token for authentication)
    const likeCourseComment = async (commentId, payload) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: UPDATE_COURSE_COMMENT_BEGIN, payload: true });

            // Calling API to update course comment like
            let coursesData = await putCourseCommentLike(commentId, payload);
            // let coursesData = [];

            // Dispatching the actions on success
            dispatch({ type: UPDATE_COURSE_COMMENT_SUCCESS, payload: coursesData })

            // Showing the toast message on updating like to the course comment successfully
            // showToast("success", "Adding like to the course comment successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.error('236 : courses_context : Error while liking comment to the course::', error && JSON.stringify(error));

            // Dispatching the actions on error 
            dispatch({ type: UPDATE_COURSE_COMMENT_FAILURE, payload: error && error.message });

            // Showing the toast message on adding like to the course comment unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to like to the course comment!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to delete course comment (requires token for authentication)
    const deleteCourseComment = async (commentId) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: DELETE_COURSE_COMMENT_BEGIN, payload: true });

            // Calling API to del course comment
            let coursesData = await delCourseComment(commentId);
            // let coursesData = [];

            // Dispatching the actions on success
            dispatch({ type: DELETE_COURSE_COMMENT_SUCCESS, payload: { coursesData, id: commentId } })

            // Showing the toast message on comment delete successfully
            showToast("success", "Comment Deleted successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.error('263 : courses_context : Error while deleting comment to the course::', error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: DELETE_COURSE_COMMENT_FAILURE, payload: error && error.message });

            // Showing the toast message on deleting course comment unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to delete this course comment!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to set filter courses
    const setFilteredCourses = (searchTerm) => {

        // Dispatching the actions on success
        dispatch({ type: GLOBAL_SEARCH_COURSES_SUCCESS, payload: searchTerm });
    }

    // Function to post user reaction to course (requires token for authentication)
    const handlePostUserReaction = async (payload, id) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: SET_USER_REACTION_BEGIN, payload: true });

            // Calling API to post userReactions 
            let response = await postUserReactions(payload);

            // let response = [];

            // Dispatching the actions on success
            dispatch({ type: SET_USER_REACTION_SUCCESS, payload: response });
            getCourseUserReaction(id)

            // Showing the toast message on reaction submitted successfully
            // showToast("success", "Reaction is submitted Successfully", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("299 : courses_context : Error while setting user reaction to course::", error && JSON.stringify(error.message));

            // Dispatching the actions on error
            dispatch({ type: SET_USER_REACTION_FAILURE, payload: error && error.message });

            // Showing the toast message on unsuccessfull reaction submission
            showToast("error", (error && error.message) ? "We are unable to submit your reaction at this moment. Please try again later!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }

    // Function to get coures user reaction (requires token for authentication)
    const getCourseUserReaction = async (courseId) => {
        try {

            // Dispatching the action to begin  the api calling process
            dispatch({ type: GET_COURSE_USER_REACTION_BEIGN, payload: true });

            // Calling API to get userReactions 
            let response = await getUserReactionsByParentId(courseId);
            // let response = [];

            // Dispatching the actions on success
            dispatch({ type: GET_COURSE_USER_REACTION_SUCCESS, payload: { courseId: courseId, userCourseReactions: response || [] } });

            // Showing the toast message on reaction getting successfully
            // showToast("success", "Getting course reaction successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("326 : courses_context : Error while fetching course reactions::", error && JSON.stringify(error.message));

            // Dispatching the actions on error
            dispatch({ type: GET_COURSE_USER_REACTION_FAILURE, payload: error.message });

            // Showing the toast message on getting user reaction unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the latest user reaction!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }

    useEffect(() => {

        if (coursesDomain !== "all") {
            fetchCourses();
        }
    }, []);

    useEffect(() => {

        if (coursesDomain !== currentDomain) {
            setCurrentDomain(currentDomain);
        }
    }, [courseState]);

    return (
        <CoursesContext.Provider value={{ ...courseState, getFilteredCourseComment, fetchCourses, updateCourseLikes, insertCourseComment, updateCourseComment, likeCourseComment, deleteCourseComment, setFilteredCourses, handlePostUserReaction, getCourseUserReaction, fetchCourseComments }}>
            {props.children}
        </CoursesContext.Provider>
    )
}
export const useCoursesContext = () => {
    return useContext(CoursesContext)
}
